import React, { useEffect, useState } from 'react'
import styles from './depositeamt.module.scss'
import axios from 'axios'
import { addDeposite, getPaymentChannel } from '../../api/api'
import UserBalance from '../userbalance/UserBalance'
import Navbar from '../navbar/Navbar'
import gpay from "../ui/images/gpay.png"
import phonepe from "../ui/images/phonepe.png"
import paytm from "../ui/images/paytm.png"




const Deposit = () => {

  const [amount, setAmount] = useState(500);
  const [amountError, setAmountError] = useState(false)
  const [paymentErrorRes,setPaymentErrorRes] = useState("")
  const [paymentError,setPaymentError] = useState(false)
  const [paymentChaData,setPaymentChaData]=useState([])
  const [activePg,setActivePg]=useState(0);
  const [channelId,setChannelId] = useState()

  let minvalue = 500
  let maxvalue = 30000
  
  const amt_list = [
    { name: "₹ 500.00", value: 500 },
    { name: "₹ 1000.00", value: 1000 },
    { name: "₹ 5000.00", value: 5000 },
    { name: "₹ 10,000.00", value: 10000 },
    { name: "₹ 20,000.00", value: 20000 },
    { name: "₹ 30,000.00", value: 30000 },
  ]

  


  const onSubmitAddCash = async () => {
    if (amount < minvalue || amount > maxvalue || isNaN(amount)) {
      setAmountError(true)
    } else {
      try {
        const res = await addDeposite({
          amount: amount * 100,
          ipAddress: "122121212",
          channelType: "WEBUSER",
          channelId:channelId
        })
        console.log(res,"sjabjsauuuuu");
        
        if(res.status === 200){
          window.location.href = res.data.data.paymentLink;
          setPaymentError(false)
          setAmountError(false)
          setAmount(500)
        }
      } catch (error:any) {
        setPaymentError(true)
        setAmountError(false)
        setPaymentErrorRes(error?.response?.data?.message)
      }
    }
  }

  const openPaymentPage = (url: string) => {
    const form = document.createElement('form');
    form.method = 'GET';
    form.action = url;
    form.target = '_blank';
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const paymentChannel =async () =>{
    const isActiveChannel = {"ispublished":true}
    const  res = await getPaymentChannel(isActiveChannel)
    if (res?.status === 200) {
      setPaymentChaData(res?.data?.data)
    }
  }

  useEffect(()=>{
    paymentChannel()
  },[])

  const handlePgClick = (idx:any,id:any) => {
    setChannelId(id)
    setActivePg(idx)
  }

  return (
    <>
      <div>
        <div className={styles.nav_GCont}>
          <Navbar name={"Recharge"} />
        </div>
        <main className={styles.deposite_amt_main_wrap}>

          <UserBalance balancetype={"Available Balance"}/>
          <section className={styles.deposit_box_wrap}>
            <h3 className={styles.deposite}>Make a Deposite</h3>

            <div>
              <input type='number' placeholder='Enter a Amount' value={amount}
                onChange={(e) => setAmount(+e.target.value)}
                className={styles.amt_input} />
              {
                amountError && <p className={styles.error_msg}>Please Enter the valid amount</p>
              }
              {
                paymentError && <p className={styles.error_msg}>{paymentErrorRes}</p>
              }

              <div className={styles.amt_val}>
                <p className={styles.min}>Minimum - {minvalue}</p>
                <p className={styles.min}>Maximum - {maxvalue}</p>
              </div>
            </div>

            <div className={styles.amt_list_wrap}>
              {
                amt_list.map((list: any) => {
                  return (
                    <div className={` ${
                      amount === list.value ? styles.selected : styles.amt_value
                    }`}>
                      <p onClick={() => setAmount(list.value)}>{list.name}</p>
                    </div>
                  )
                })
              }
            </div>
          </section>

          <div className={styles.recharge_channels}>
            {
              paymentChaData?.map((cha:any,i:any)=>{
                return (
                  <div className={`${styles.pg_fields} ${activePg === i && styles.activePg}`} onClick={()=>handlePgClick(i,cha?.id)}><img src={cha?.image} alt={cha?.image} className={styles.pg_img}/>
                  <span className={styles.pg_name}>{cha?.name}</span>
                  </div>
                )
              })
            }             
          </div>

          <section className={styles.pay_button_wrap}>
            <p className={styles.btn_info}>By completing, you confirm your acceptance of the Offer T&C and Bonus T&C</p>
            <button className={styles.pay_btn} onClick={onSubmitAddCash}>Pay {amount}</button>
          </section>
        </main>
      </div>
    </>
  )
}

export default Deposit
